import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { EliminaOndemandBackofficeComponent } from './elimina-ondemand-backoffice/elimina-ondemand-backoffice.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Ondemand, UserBackoffice } from '../../../shared/interfacce.model';
import { ApiService } from '../../../services/api.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-ondemand-backoffice',
  templateUrl: './ondemand-backoffice.component.html',
  styleUrls: ['./ondemand-backoffice.component.css']
})
export class OndemandBackofficeComponent implements OnInit {

  ondemands: Ondemand[] = [];

  titoloFilter: any = '';
  canaleFilter: any = '';

  user?: UserBackoffice;

  constructor(private apiService: ApiService, private storageService: StorageService, private router: Router, private modal: NzModalService, private viewContainerRef: ViewContainerRef) { }

  ngOnInit(): void {

    // Recupero l'utente loggato
    this.user = this.storageService.getUserBackoffice();

    // Recupero gli ondemand
    this.apiService.setOndemands();
    this.apiService.ondemandChanged.subscribe({
      next: (data) => {
        // Se l'utente è amministratore recupero tutti gli ondemand
        if (this.user?.tipo == 'Amministratore')
          this.ondemands = data;
        else {
          // Filtro gli ondemand per il canale legato all'utente
          this.ondemands = data.filter(ondemand => ondemand.id_canale.indexOf(this.user?.id_canale.toString() || '') >= 0 )
        }
      },
      error: (err) => this.router.navigate(['/backoffice/ondemand']),
      complete: () => { }
    })

  }

  onAdd() {
    this.router.navigate(['/backoffice/ondemand/add']);
  }

  onEdit(id: number) {
    this.router.navigate(['/backoffice/ondemand/' + id])
  }

  onElimina(id: number) {
    this.modal.create({
      nzTitle: 'Conferma',
      nzContent: EliminaOndemandBackofficeComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzData: {
        id_ondemand: id
      },
      nzFooter: null,
      nzCentered: true,
      nzWidth: 750,
      nzBodyStyle: { 'padding': '0px' }
    });
  }

  onOrdinamentoTitolo(a: Ondemand, b: Ondemand) {
    return a.titolo.localeCompare(b.titolo)
  }

  onOrdinamentoCanale(a: Ondemand, b: Ondemand) {
    return a.canale.localeCompare(b.canale)
  }

  onOrdinamentoCategoria(a: Ondemand, b: Ondemand) {
    return a.categoria.localeCompare(b.categoria)
  }

}
